export class Referent {
    constructor(
        public id?: number,
        public prenom?: string,
        public nom?: string,
        public email?: string,
        public etablissement?: string,
        public discipline?: string,
        public position?: string,
        public key?: string,
        public savedDate?: any,
        public formulaire?: string,
        public formation?: string,
        public ects?: number,
        public candidat?: string,
        public candidatureFormationId?: number,
        public invalid?: boolean,
        public typeReferent?: String ,
        public questions?: any[],
        public dateRelance?: any,
        public nombreRelance?: Number,
        public obligatoire?: boolean
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/referent/referent.model.ts